import { StateCreator } from 'zustand';
import { ISelectedChatFields, ISelectedChatSlice } from './type';
import { chatApi } from '@/API';
import {
  TChatMessageRequestCamel,
  TPatchChatRequestCamel,
  TPostChatEventRequestCamel,
  TPutChatParticipantsRequestCamel,
} from '@/types/chats';
import { convertKeys } from '@/utils/common';

const initState: ISelectedChatFields = {
  selectedChat: null,
  loadingSelectedChat: false,
};

export const createSelectedChatSlice: StateCreator<ISelectedChatSlice> = (
  set,
  get,
) => ({
  ...initState,
  getSelectedChat: async (chatId: string) => {
    set({ loadingSelectedChat: true });
    try {
      const response = await chatApi.getChat(chatId);
      set({ selectedChat: convertKeys(response.data.data) });
      return convertKeys(response.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      set({ loadingSelectedChat: false });
    }
  },

  sendMessageInChat: async (chatId: string, body: TChatMessageRequestCamel) => {
    try {
      await chatApi.sendMessageInChat(chatId, convertKeys(body, 'snake'));
    } catch (err) {
      console.error(err);
    }
  },

  putChatParticipants: async (
    id: string,
    body: TPutChatParticipantsRequestCamel,
  ) => {
    await chatApi.putChatParticipants(id, convertKeys(body, 'snake'));
  },

  updateChat: (chat) => {
    const { selectedChat } = get();
    if (chat.id !== selectedChat?.id) return;
    set({ selectedChat: chat });
  },

  patchChat: async (chatId: string, body: TPatchChatRequestCamel) => {
    await chatApi.patchChat(chatId, convertKeys(body, 'snake'));
  },
  postChatEvent: async (chatId: string, body: TPostChatEventRequestCamel) => {
    await chatApi.postChatEvent(chatId, convertKeys(body, 'snake'));
  },

  changeFieldSelectedChat: (stateField, field) => {
    set((state) => {
      const selectedChat = state.selectedChat;
      if (!selectedChat) return state;
      return {
        ...state,
        selectedChat: {
          ...selectedChat,
          [field]: stateField,
        },
      };
    });
  },
  clearSelectedChat: () => set(initState),
});
